import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getWidthAndHeight(oWidth, oHeight, maxSize) {
  var tmp0 = maxSize / oWidth;
  // Inline function 'kotlin.math.min' call
  var b = maxSize / oHeight;
  var ratio = Math.min(tmp0, b);
  if (ratio > 1)
    return to(oWidth, oHeight);
  return to(numberToInt(oWidth * ratio), numberToInt(oHeight * ratio));
}
function renderImageThumbnail(_this__u8e3s4, maxSize, $completion) {
  var reader = new FileReader();
  var image = new Image();
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.ta5();
  var cont = cancellable;
  reader.onload = (rEvent) => {
    image.onload = (_unused_var__etf5q3) => {
      var tmp = document.createElement('canvas');
      var canvas = tmp instanceof HTMLCanvasElement ? tmp : THROW_CCE();
      var _destruct__k2r9zo = getWidthAndHeight(image.width, image.height, maxSize);
      var width = _destruct__k2r9zo.cf();
      var height = _destruct__k2r9zo.df();
      canvas.width = width;
      canvas.height = height;
      // Inline function 'kotlin.apply' call
      var this_0 = canvas.getContext('2d');
      if (!(this_0 instanceof CanvasRenderingContext2D))
        THROW_CCE();
      this_0.drawImage(image, 0.0, 0.0, width, height);
      canvas.toBlob((it) => {
        var tmp0 = cont;
        var tmp;
        if (it == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_0 = [it];
          // Inline function 'org.w3c.files.FilePropertyBag' call
          var type = 'image/webp';
          var lastModified = undefined;
          var o = {};
          o['lastModified'] = lastModified;
          o['type'] = type;
          var temp = new File(tmp_0, 'thumbnail.webp', o);
          tmp = temp;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          throw Exception().ud('Failed to render Image');
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = tmp_1;
        var tmp$ret$6 = _Result___init__impl__xyqfz8(value);
        tmp0.rc(tmp$ret$6);
        return Unit_instance;
      }, 'image/webp', 0.75);
      return Unit_instance;
    };
    var tmp0_safe_receiver = rEvent.target;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp0_safe_receiver;
    }
    var tmp1_safe_receiver = tmp;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$11 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.result;
    image.src = tmp$ret$11;
    return Unit_instance;
  };
  reader.readAsDataURL(_this__u8e3s4);
  cont.va7((it) => {
    reader.abort();
    return Unit_instance;
  });
  return cancellable.ua5();
}
//region block: exports
export {
  renderImageThumbnail as renderImageThumbnail1u1tdw31b219h,
};
//endregion

//# sourceMappingURL=FileReference.ext.js.mjs.map
